import { render, staticRenderFns } from "./SalesInvoicesDefaultTab.vue?vue&type=template&id=0e690981&scoped=true"
import script from "./SalesInvoicesDefaultTab.vue?vue&type=script&lang=ts"
export * from "./SalesInvoicesDefaultTab.vue?vue&type=script&lang=ts"
import style0 from "./SalesInvoicesDefaultTab.vue?vue&type=style&index=0&id=0e690981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e690981",
  null
  
)

export default component.exports